import React, { useRef } from 'react';

import AreaList from './AreaList';
import Col from 'react-bootstrap/Col';
import EditorSaveScheduleCancel from '../shared/buttons/EditorSaveScheduleCancel';
import Form from 'react-bootstrap/Form';
import permissionsProvider from '../../utilities/permissionsProvider';

const EditForm = ({
    cancelEdit,
    editId,
    form: { formChange },
    form: { item },
    schedule,
    submitForm
}) => {

    const disabled = !permissionsProvider.canEdit(item.acl);

    const formRef = useRef(null);

    return (
        <div>
            <Form method="post" action="/calendar/scheduleNewSalesAppointment" ref={formRef} className="item-editor">
                <Form.Row>
                    <Form.Group as={Col} sm>
                        <Form.Control
                            as="textarea"
                            className="form-control"
                            defaultValue={item.note}
                            disabled={disabled}
                            name="note"
                            onChange={formChange}
                            placeholder="Appointment Notes"
                            rows="6" />
                        <input type="hidden" name="customerId" value={item.customerId} />
                    </Form.Group>
                    <Col sm>
                        <AreaList
                            disabled={disabled}
                            formChange={formChange}
                            items={item.areasInterestedIn}
                            salesAppointmentId={editId} />
                    </Col>
                </Form.Row>
            </Form>
            <EditorSaveScheduleCancel
                middleButtonAction={() => schedule({ item: { id: item.id } })}
                middleButtonImg="/images/schedule.svg"
                reschedule={item.appointmentDate}
                scheduleAction={() => submitForm(schedule)}
                save={item.appointmentDate ? submitForm : () => formRef.current.submit()}
                cancel={cancelEdit}
                acl={item.acl}
                appointmentId={item.id}
                appointmentType={1}
            />
        </div>
    );
}

export default EditForm;